import { RouteProps } from '../../routes/AppRouter'
import { ArticlesView as A } from '../../features/article'
import { useTitleHeaderContext } from '../../common/utils/TitleHeaderContext'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremePlusLogo.svg'
import style from '../layout/Main.module.css'
import React from 'react'
import { useParams } from 'react-router-dom'

export function ArticlesView(props: RouteProps) {
  const title = props.title || ''
  const { setTitle } = useTitleHeaderContext()
  const { id } = useParams()

  setTitle(title)
  return (
    <>
      <A id={id} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
